(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-rmc-carousel]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const track = section.querySelector('.rmc-fanshop__track');
      const controls = section.querySelector('[data-carousel-controls]');
      const previous = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      function update() {
        const end = track.scrollWidth - track.clientWidth;
        controls.hidden = end <= 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
      }
      function move(direction) {
        const card = track.firstElementChild;
        const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap) : track.clientWidth;
        track.scrollBy({ left: direction * distance, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-rmc-sort]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
